<div
  id="{{elementsIdentifiers.wholeElementId}}"
  class="customSelectElementWrapper"
  (click)="elementClickHandler($event)"
  [style]="externalStyles?.elementWrapperStyle"
>
  <div
    id="{{elementsIdentifiers.valueContainerId}}"
    class="valueContainer"
  >
    <div
      id="{{elementsIdentifiers.labelId}}"
      class="labelStyle"
      [ngClass]="labelStyles()"
      [title]="labelText"
    >
      {{labelText}}
    </div>
    <div
      id="{{ elementsIdentifiers?.selectedValueId}}"
      class="selectedValueSectionStyle"
    >
      <div
        class="selectedValueStyle"
        title="{{optionTransformer(selectedOption)}}"
      >
        {{optionTransformer(selectedOption)}}
      </div>
    </div>
  </div>
  <div
    id="{{elementsIdentifiers?.iconContainerId}}"
    class="iconContainerStyle"
    [style]="externalStyles?.iconContainerStyle"
  >
    <mat-icon
      class="matIconCommonStyle"
      [ngClass]="iconStyles()"
    >
      expand_more
    </mat-icon>
  </div>
  <div
    *ngIf="isVisible"
    class="optionsWrapper"
    [style]="externalStyles?.optionsWrapperStyle"
  >
    <div
      *ngFor="let option of optionsList; index as i"
      class="singleOptionWrapper"
      tabindex="{{i + 1}}"
      id="{{elementsIdentifiers.selectedValueId + i}}"
      [style]="externalStyles?.singleOptionWrapper"
    >
      {{optionTransformer(option)}}
    </div>
  </div>
  <div
    id="{{this.elementsIdentifiers.backDropId}}"
    *ngIf="isVisible"
    class="backDropStyle"
  ></div>
</div>
